import React, { Component } from 'react';
import loadScripts  from '../../dassets/js/custom';
import { Link } from 'react-router-dom';
import api from '../api';
import { toast } from 'react-toastify';
import store from "../redux/store";

class Faqs extends Component {
  constructor(props) {
    super(props);  

  this.state = {
      contents: [],
  }
}

componentDidMount() {
  loadScripts();
  this.fetchContents();
}

fetchContents() {
  api.get(`/getContents?page=faq`)
  .then(response => {
    const contents = response.data.data;
    contents.sort((a, b) => a.order - b.order)
    this.setState({
        contents: contents
    });
  }).catch(error => {
      let err = store.getState().error;
      if (err) {
          toast.error(err.message);
          this.props.history.push(err.redirectUrl)
      }
      console.log(error)
  });
}
  render() {
    return (
      <>
      {/* =================================
    Inner Header */}
    <div className="inner-header bg-light">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-sm-6 text-sm-start mb-2 mb-sm-0">
            <h1 className="breadcrumb-title mb-0">FAQs</h1>
          </div>
          <div className="col-sm-6">
            <ol className="breadcrumb d-flex justify-content-center justify-content-sm-end ms-auto">
              <li className="breadcrumb-item"><Link to={"/"}><i className="fas fa-home me-1"></i>Home</Link></li>
              <li className="breadcrumb-item active"><span>FAQs</span></li>
            </ol>
          </div>
        </div>
      </div>
    </div>
  {/* =================================
  Inner Header */}

  
  <section className="space-ptb">
    <div className="container">
      <div className="row justify-content-center">
        <div className="col-lg-8">
        <div className="accordion accordion-style-2" id="accordion-style-2">

        {this.state.contents.map((content, i) => {
                        return <div key={i} className="card">
                        <div className="accordion-icon card-header" id={`${i}-accordion-item-2`}>
                          <h6 className="mb-0">
                          <button className={`btn ${i == 0 ? "" : "collapsed"}`} type="button" data-bs-toggle="collapse" data-bs-target={`#collapse-${i}-accordion-item-2`} aria-expanded="false" aria-controls={`collapse-${i}-accordion-item-2`}>
                          {i+1}&nbsp;{content.title}
                          </button>
                          </h6>
                        </div>
                        <div id={`collapse-${i}-accordion-item-2`} className={`collapse ${i == 0 ? "show" : ""}`} aria-labelledby={`${i}-accordion-item-2`} data-bs-parent="#accordion-style-2">
                        <div className='card-body' dangerouslySetInnerHTML={{ __html: content.description }} />
                        </div>
                      </div> })}
            </div>
        </div>
      </div>
    </div>
  </section>
      </>
    );
  }
}

export default Faqs